module.exports = __webpack_public_path__ + "img/icons BFr_28.1966d88a.png";